import React from "react";
import injectSheet from "react-jss";

const styles = ({ theme }) => {
  return {
    root: {
      marginBottom: 36
    }
  };
};
const Section = ({ classes, children }) => {
  return <div className={classes.root}>{children}</div>;
};

Section.propTypes = {};

export default injectSheet(styles)(Section);
